import { render } from "./bookMark.vue?vue&type=template&id=d956e6be&scoped=true"
import script from "./bookMark.vue?vue&type=script&lang=js"
export * from "./bookMark.vue?vue&type=script&lang=js"

import "./bookMark.vue?vue&type=style&index=0&id=d956e6be&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d956e6be"]])

export default __exports__